import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import DeleteCustomer from '../DeleteCustomer'
import ResetPassword from '../ResetPassword'
import { Button, Spinner } from 'react-bootstrap';

function EditCustomerTopBar(props) {
    const { loading, step } = props
    const [deleteCustomer, setDelete] = useState(false)
    const [resetPassword, setPassword] = useState(false)

    return (
        <React.Fragment>
            <div className="cats-all-btns d-flex border-bottom justify-content-between st-border-light pad-15-R">
                <div className="cats-all-btns d-flex  pad-12-R">
                    {deleteCustomer && <DeleteCustomer
                        show={deleteCustomer}
                        closeModal={() => { setDelete(false) }}
                        user_id={props.userId}
                        onDelete={(userId) => {
                            props.handleDelete(userId)
                        }}
                    />}

                    {resetPassword && <ResetPassword show={resetPassword}
                        closeModal={() => { setPassword(false) }}
                        user_id={props.userId}
                    />}
                    <div className="cats-all-btns-inner d-flex flex-wrap justify-content-start  pad-12-B">
                        <div className="mb-0 app-header-wrapper heading-md d-flex align-items-center justify-content-start customer-top-heading">
                            <p className="app-heading text-capitalize">Customer Information</p>
                        </div>
                    </div>
                    <div className="cats-all-btns-inner d-flex flex-wrap align-items-center justify-content-start  pad-L-12 customer-top-button pad-12-B">
                        <Link
                            to="#"
                            className="st-btn st-btn-sm  st-btn-link d-flex align-items-center justify-content-center st-border-light"
                            onClick={() => { }}
                        >
                            <FeatherIcon
                                icon="log-in"
                                size="14"
                                className="icon me-1" />
                            <span>Login as Customer</span>
                        </Link>
                        <Link
                            to="#"
                            className="st-btn st-btn-sm st-btn-link d-flex align-items-center justify-content-center"
                            onClick={() => { setDelete(true) }}
                        >
                            <FeatherIcon
                                icon="trash-2"
                                size="14"
                                className="icon me-1" />
                            <span>Delete Customer</span>
                        </Link>
                        <Link
                            to={{
                                pathname: '/my-sales/sale-orders/create/' + props.userId,
                                // state: { customerDetails: item }
                            }}
                            type="button"
                            className="st-btn st-btn-sm st-btn-link d-flex align-items-center justify-content-center "
                        >
                            <FeatherIcon
                                icon="file-plus"
                                size="14"
                                className="icon me-1" />
                            <span>Create Order</span>
                        </Link>
                        <Link
                            to="#"
                            className="st-btn st-btn-sm st-btn-link d-flex align-items-center justify-content-center "
                            onClick={() => { setPassword(true) }}
                        >
                            <FeatherIcon
                                icon="rotate-ccw"
                                size="14"
                                className="icon me-1" />
                            <span>Reset Password</span>
                        </Link>
                        {/* <div className="header d-flex p-0" style={{ height: "auto" }}>
                            <div className="header-menu d-flex">
                                <div className="hm_item notifications">
                                    <Link
                                        to="#"
                                        className="st-round-btn st-btn-sm st-btn-white d-flex align-items-center justify-content-center"
                                    >
                                        <FeatherIcon
                                            icon="more-vertical"
                                            size="15"
                                            className="icon-main" />
                                    </Link>
                                    <div className="header-dropdown w-50">
                                        <div className="hd_inner st-default-rounded-block ">
                                            <div className="all-links">
                                                <Link to="#" className="link-item text-decoration-none d-flex">
                                                    <div className="text media-body ps-3">
                                                        <p className="message st-fs-14">
                                                            More
                                                        </p>
                                                    </div>
                                                </Link>
                                                <Link to="#" className="link-item text-decoration-none d-flex">
                                                    <div className="text media-body ps-3">
                                                        <p className="message st-fs-14">
                                                            More 2
                                                        </p>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="cats-all-btns d-flex pad-12-L pad-12-B">
                    <div className="cats-all-btns-inner d-flex flex-wrap justify-content-end  customer-right-btn ">
                        <Link to="/my-sales/customers" className="st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2">
                            <FeatherIcon
                                icon="delete"
                                size="14"
                                className="icon me-1" />
                            Back
                        </Link>
                        <Button
                            type="submit"
                            className={`st-btn st-btn-sm st-btn-primary d-flex align-items-center justify-content-center ${(step === 1 || step === 3) ? "" : "disabled"}`}
                            onClick={(e) => {
                                props.handleFormSubmission(e)
                            }}
                            disabled={loading}
                        >
                            {loading ? <Spinner animation="border" size="sm" />
                                : <span>Update Customer</span>
                            }
                        </Button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )

}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditCustomerTopBar)